// extracted by mini-css-extract-plugin
module.exports = {"navbar-brand":"appNav_navbar-brand__367Ka","nav-item":"appNav_nav-item__3McRM","nav-buttons":"appNav_nav-buttons__3r6ER","dropdown-item":"appNav_dropdown-item__1kNpB"};